export default __webpack_public_path__ + "static/reward-stacking-70c755101c195e4d570a5c72fc6ef4f5.svg";